import React from 'react';
import './IconCard.css'
import icon7 from './../assets/icon-7.png'
import Title from './Title';
import Paragraph from './Paragraph';
import icon8 from './../assets/icon-8.png'
import icon9 from './../assets/icon-9.png'
import icon10 from './../assets/icon-10.png'

const IconCard = () => {
    return (<>
    <div className='cardcon'>
        <div className='card'>
            <div className='icon-box2'>
                <img src={icon7}/>
            </div>
            <Title text4='30+' css0='text0'/>
            <Title text5='Years Experience' css11='text11'/>
            <Paragraph text4='Established legal practice since 1995' css12='paragraph4'/>
        </div>

        <div className='card'>
            <div className='icon-box2'>
                <img src={icon8}/>
            </div>
            <Title text4='500+' css0='text0'/>
            <Title text5='Cases Won' css11='text11'/>
            <Paragraph text4='Successfully resolved complex matters' css12='paragraph4'/>
        </div>

        <div className='card'>
            <div className='icon-box2'>
                <img src={icon9}/>
            </div>
            <Title text4='98+' css0='text0'/>
            <Title text5='Success Rate' css11='text11'/>
            <Paragraph text4='Consistently favorable outcomes' css12='paragraph4'/>
        </div>

        <div className='card'>
            <div className='icon-box2'>
                <img src={icon10}/>
            </div>
            <Title text4='100+' css0='text0'/>
            <Title text5='Client Satisfaction' css11='text11'/>
            <Paragraph text4='Commitment to excellence and service' css12='paragraph4'/>
        </div>
    </div>
    </>);
}
 
export default IconCard;